function MedicalPostMeedyVO(id, name, address, correspondenceAddressType, correspondenceAddressResourceId, correspondenceAddressOther, alabPaymentType, p1Certificates, oid, resortCodeI, medicalPostRegon, p1CertificateType, medicalChamber, medicalChamberEntryNumber) {


    this.id = id;
    this.name = name;
    this.address = address;
    this.correspondenceAddressType = correspondenceAddressType;
    this.correspondenceAddressResourceId = correspondenceAddressResourceId;
    this.correspondenceAddressOther = correspondenceAddressOther;
    this.alabPaymentType = alabPaymentType;
    this.p1Certificates = p1Certificates;
    this.oid = oid;
    this.resortCodeI = resortCodeI;
    this.medicalPostRegon = medicalPostRegon;
    this.p1CertificateType = p1CertificateType;
    this.medicalChamber = medicalChamber;
    this.medicalChamberEntryNumber = medicalChamberEntryNumber;

    if (_.isUndefined(this.correspondenceAddressType)) {
        this.correspondenceAddressType = Enum.MEEDY.CORRESPONDENCE_ADDRESS_TYPE.MEDICAL_POST;
    }

    if (_.isUndefined(this.alabPaymentType)) {
        this.alabPaymentType = null;
    }

    var _typeContext = {
        address : AddressMeedyVO,
        correspondenceAddressOther : AddressMeedyVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
